export const styles = {
  label: '!text-text-50 callout-normal',
  value: '!text-text-100 body-normal whitespace-normal break-words',
};

export const cancellationReasons: { [key: number]: string } = {
  0: 'Отсутствует',
  1: 'Возврат средств',
  2: 'Чек сформирован ошибочно ',
};